import { render, staticRenderFns } from "./FoodStatsNavigation.vue?vue&type=template&id=861ace9e"
import script from "./FoodStatsNavigation.vue?vue&type=script&lang=js"
export * from "./FoodStatsNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports